<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-dialog-container account-routing-container paybee-modal-content">
    <div class="modal-header">
      <div class="row">
        <div class="col-8">
          <div class="step-title">Account</div>
        </div>
        <div class="col-4 text-right">
          <app-icon-mini-cheque></app-icon-mini-cheque>
        </div>
      </div>

      <div class="step-description mb-2">
        Link a bank account using routing and account number
      </div>
    </div>
    <div class="modal-body" [formGroup]="form">
      <div class="row field-container">
        <div class="col-12">
          <mdb-form-control class="form-fill" >
            <app-mdbp-input mdbInput formControlName="routing_number" appNumbersOnly  maxLength="128" label='Routing Number'></app-mdbp-input>
  
           </mdb-form-control>
          <div class="mat-form-field-description mb-3 pr-5">
            <div class="mat-error">{{ getRoutingNumber() }}</div>
            <div class="routing desc-text">This is 9-digit number in the bottom corner of the check.</div>
          </div>
        </div>
      </div>
      <div class="row field-container">
        <div class="col-12">
          <mdb-form-control class="form-fill" >
            <app-mdbp-input mdbInput formControlName="account_number" appNumbersOnly  maxLength="128" label='Account Number'></app-mdbp-input>
           </mdb-form-control>
          <div class="mat-form-field-description mb-3 pr-5">
            <div class="mat-error">{{ getAccountNumber() }}</div>
            <div class="account desc-text">This is the second set of numbers in the bottom left corner.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer paybee-modal-footer">
      <div class="row">
        <div class="col text-right">
          <button type="button" class="btn btn-sm modal-cancel-button close-action" (click)="close(dialog, true)">Close</button>
          <button type="button" class="btn btn-sm modal-confirm-button confirm-action" (click)="confirm(dialog, true)">Link</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
